"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactSegmentWrapperError = exports.ErrorMessage = void 0;
var ErrorMessage;
(function (ErrorMessage) {
    ErrorMessage["NOT_BROWSER"] = "SegmentWrapper must be initialized in a browser environment";
    ErrorMessage["MISSING_SITE_ID"] = "SegmentWrapper must be initialized with a siteId";
    ErrorMessage["MISSING_VISIT_ID"] = "SegmentWrapper must be initialized with a visitId";
})(ErrorMessage || (exports.ErrorMessage = ErrorMessage = {}));
class ReactSegmentWrapperError extends Error {
    constructor(message) {
        super(message);
        this.name = "ReactSegmentWrapperError";
    }
}
exports.ReactSegmentWrapperError = ReactSegmentWrapperError;
//# sourceMappingURL=errors.js.map